import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import OverviewPopover from './OverviewPopover';
import { ReactComponent as MailIcon } from '../../../images/icons/mail.svg';
import { ReactComponent as CallIcon } from '../../../images/icons/call.svg';

export interface ContactActionCellProps {
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
}

// Call / e-mail actions for a patient row in the survey detail panels.
const ContactActionCell = ({
  contactName,
  contactPhone,
  contactEmail,
}: ContactActionCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleEmailClick = () => {
    if (contactEmail) {
      window.location.href = `mailto:${contactEmail}`;
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      borderRadius="8px"
      border="1px solid var(--Outline-O5---Separator, #D4D4D9)"
    >
      <IconButton
        size="small"
        onClick={handleOpenModal}
        sx={{
          marginX: '4px',
          width: 32,
          height: 32,
          p: 0,
        }}
      >
        <CallIcon style={{ width: 20, height: 20 }} />
      </IconButton>

      <Box
        width="1px"
        height="32px"
        bgcolor="var(--Outline-O5---Separator, #D4D4D9)"
      />
      <IconButton
        size="small"
        onClick={handleEmailClick}
        sx={{
          marginX: '4px',
          width: 32,
          height: 32,
          borderRadius: '12px',
          p: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <MailIcon style={{ width: 20, height: 20 }} />
      </IconButton>
      {isModalOpen && (
        <OverviewPopover
          onClose={handleCloseModal}
          contactName={contactName}
          contactPhone={contactPhone}
        />
      )}
    </Box>
  );
};

export default ContactActionCell;
